import { useEffect, useRef } from 'react';
import { testimonials } from '../../../data/testimonials';

export default function Testimonials() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.12 }
    );
    const cards = sectionRef.current?.querySelectorAll('.fade-up');
    cards?.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="depoimentos" ref={sectionRef} className="py-28" style={{ background: 'transparent' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14 fade-up">
          <span
            className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold mb-4"
            style={{ background: 'var(--badge-bg)', color: 'var(--gold-hover)', fontFamily: "'DM Sans', sans-serif", border: '1px solid rgba(200,131,42,0.15)' }}
          >
            Histórias reais, emoções de verdade
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 800, letterSpacing: '-0.03em' }}
          >
            Quem já emocionou alguém
          </h2>
          <p
            className="text-base max-w-md mx-auto"
            style={{ color: 'var(--text-strong)', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
          >
            Mais de 1.200 histórias transformadas em música. Aqui estão algumas delas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {testimonials.map((t, index) => (
            <div
              key={t.id}
              className="glass home-card fade-up p-7 rounded-2xl"
              style={{
                backdropFilter: 'blur(18px)',
                WebkitBackdropFilter: 'blur(18px)',
                border: t.highlight ? '1.5px solid rgba(200,131,42,0.30)' : '1px solid rgba(0,0,0,0.06)',
                boxShadow: t.highlight
                  ? '0 4px 24px rgba(200,131,42,0.09), 0 1px 4px rgba(0,0,0,0.04)'
                  : '0 1px 4px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.03)',
                transitionDelay: `${index * 0.1}s`,
              }}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" style={{ color: 'var(--gold)' }} />
                ))}
              </div>

              {/* Quote */}
              <p
                className="text-base leading-relaxed mb-5 italic"
                style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 400 }}
              >
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div
                  className="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center"
                  aria-hidden
                  style={{
                    background: `linear-gradient(135deg, ${t.hue} 0%, var(--amber-deep) 100%)`,
                    color: '#fff',
                    fontFamily: "'DM Sans', sans-serif",
                    fontWeight: 800,
                    fontSize: '15px',
                    boxShadow: '0 2px 8px rgba(204,102,32,0.28)',
                  }}
                >
                  {t.initial}
                </div>
                <div>
                  <p
                    className="text-sm font-semibold"
                    style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif" }}
                  >
                    {t.name}
                  </p>
                  <p
                    className="text-xs"
                    style={{ color: 'var(--text-soft)', fontFamily: "'DM Sans', sans-serif" }}
                  >
                    {t.context}
                  </p>
                </div>
                {t.highlight && (
                  <span
                    className="ml-auto px-2.5 py-1 rounded-full text-xs font-medium"
                    style={{ background: 'var(--badge-bg)', color: 'var(--gold-hover)', border: '1px solid rgba(200,131,42,0.20)', fontFamily: "'DM Sans', sans-serif" }}
                  >
                    Destaque
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
